import { render, staticRenderFns } from "./TopItems.vue?vue&type=template&id=53d544c4&"
import script from "./TopItems.vue?vue&type=script&lang=js&"
export * from "./TopItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports